import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import { useCurrentAircraft } from 'ff/debrief/hooks';
import { useDebriefModal } from 'ff/debrief/modalManager';
import DebriefDialogTitle from 'ff/debrief/components/modals/DebriefDialogTitle';
import { SubmitHandler, VspeedFormValues } from './VspeedFormValues';
import VspeedOverrideForm from './VspeedOverrideForm';
import AircraftForm from './AircraftForm';

export const VspeedModal = () => {
    const { isOpen, close } = useDebriefModal('Vspeed');
    const { vSpeedOverrides, standardSpeeds, currentAircraft, setOverrides } =
        useCurrentAircraft();

    const handleSubmit: SubmitHandler = (values, helpers) => {
        const cleanedValues: VspeedFormValues = {
            vr: values.vr || null,
            vx: values.vx || null,
            vy: values.vy || null,
            vref: values.vref || null,
            vne: values.vne || null,
            vs0: values.vs0 || null,
            vs1: values.vs1 || null,
            vsw: values.vsw || null,
            vmxt: values.vmxt || null,
        };
        setOverrides(cleanedValues)
            .then(() => {
                helpers.setSubmitting(false);
                handleClose();
            })
            .catch(() => {
                helpers.setSubmitting(false);
                handleClose();
            });
    };

    const handleClose = () => {
        close();
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DebriefDialogTitle onClose={handleClose}>
                V-Speeds
            </DebriefDialogTitle>
            <DialogContent>
                <Typography mb={2}>
                    Based on the detected tail number, we&apos;ve identified
                    this aircraft. If the tail number or model is incorrect, you
                    can edit/select the correct ones using the options below.
                    This changes will impact Debrief view only.
                </Typography>
                <AircraftForm />
                <VspeedOverrideForm
                    standardSpeeds={standardSpeeds}
                    vSpeedOverrides={vSpeedOverrides}
                    onSubmit={handleSubmit}
                    onClose={handleClose}
                    isCustom={
                        currentAircraft?.model.toLocaleUpperCase() === 'CUSTOM'
                    }
                />
            </DialogContent>
        </Dialog>
    );
};
